
import { RouteInfos } from '../event/event';

declare var google;

export class EventDetailsProvider {

    private static instance: EventDetailsProvider;

    private constructor() { }

    public static getInstance(): EventDetailsProvider {
        if (!EventDetailsProvider.instance) {
            EventDetailsProvider.instance = new EventDetailsProvider();
        }

        return EventDetailsProvider.instance;
    }

    events: any = [];

    /**
     * 
     * @param events events fetched by mapinitbylid
     * initialize the provider with events
     */
    setEvents(events) {
        this.events = Object.assign([], events);
    }

    /**
     * 
     * @param id event id
     * @returns array of objects, fullPath
     * returns the fullPath for the event, returns empty array if there is no route
     */
    getEventRoute(id: number) {
        let indexOf = this.events.map(e => e.id).indexOf(id);
        let fullPath = [];

        if (indexOf > -1) {
            let data = JSON.parse(this.events[indexOf].evtInfosList[0].routeData) as RouteInfos;
            data.routeInfos.forEach(info => {
                fullPath = fullPath.concat(google.maps.geometry.encoding.decodePath(info.path));
            });
        }

        return fullPath.slice();
    }

}





// WEBPACK FOOTER //
// /src/providers/event-details/event-details.ts